var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseExpansion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1C10 0.447715 9.55229 0 9 0C8.44772 0 8 0.447715 8 1V7C8 7.48682 8.34786 7.89239 8.80857 7.9817C8.8915 7.9984 8.97614 8.0045 9.06032 8H15C15.5523 8 16 7.55228 16 7C16 6.44771 15.5523 6 15 6H11.4216L15.6968 1.72482C16.0867 1.33493 16.0867 0.702789 15.6968 0.312897C15.3069 -0.0769961 14.6748 -0.0769959 14.2849 0.312897L10 4.59778V1ZM1 8L6.99758 8H7C7.55228 8 8 8.44772 8 9L8 15C8 15.5523 7.55228 16 7 16C6.44771 16 6 15.5523 6 15L6 11.4256L1.71946 15.7061C1.32894 16.0967 0.695775 16.0967 0.305251 15.7061C-0.0852733 15.3156 -0.085273 14.6824 0.305251 14.2919L4.59717 10L1 10C0.447715 10 0 9.55229 0 9C0 8.44772 0.447715 8 1 8Z",
    fill: "#646A82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseExpansion);
export default __webpack_public_path__ + "static/media/CloseExpansion.1a757776e24e7ede05a0e9a5d64e4e11.svg";
export { ForwardRef as ReactComponent };